module.exports = __webpack_public_path__ + "img/05.prt.c23661d7.jpg";